var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsUserexperience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 27.6,
    viewBox: "0 0 46 27.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "skills_userexperience",
    d: "M7.45,37A3.436,3.436,0,0,1,4,33.55V17.45A3.436,3.436,0,0,1,7.45,14h39.1A3.436,3.436,0,0,1,50,17.45v16.1A3.436,3.436,0,0,1,46.55,37H42.87V33.55h3.68V17.45H7.45v16.1H22.63V37Zm25.3,4.6L30.68,37l-4.6-2.07,4.6-2.07,2.07-4.6,2.07,4.6,4.6,2.07L34.82,37ZM38.5,29.41l-1.207-2.7L34.59,25.5l2.7-1.207,1.207-2.7,1.208,2.7,2.7,1.207-2.7,1.208Z",
    transform: "translate(-4 -14)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsUserexperience);
export default __webpack_public_path__ + "static/media/skills_userexperience.32245e628fffbfb63761730ea53c99b7.svg";
export { ForwardRef as ReactComponent };